import React, { useEffect } from "react";
import { Row, Form, Input } from "antd";
import { MailOutlined } from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import ContactDisplay from "./ContactDisplay";

const Contact = ({ state = {}, readOnly }) => {
  const { phone, email, website, form, rules, onChange } = state;

  //for sync antd with state
  useEffect(() => {
    form?.setFieldsValue({ email, website });
  }, [email, website]);

  return readOnly ? (
    <ContactDisplay phone={phone} email={email} website={website} />
  ) : (
    <Row style={{ marginBottom: "2rem" }}>
      <Row style={{ marginBottom: "1.5rem", width: "100%" }}>
        <PhoneInput
          country="ca"
          value={phone?.substring(1)}
          countryCodeEditable={false}
          enableSearch
          inputStyle={{
            width: "100%",
            height: "2.5rem",
          }}
          onChange={(value) => {
            onChange({ phone: `+${value}` });
            // let { countryCode, number } = c.parsePhoneFromObj(value, data);
            // console.log(`+${countryCode}${number}`);
            // setPhone(`+${countryCode}${number}`);
          }}
        />
      </Row>

      <Form form={form} layout="vertical" style={{ width: "100%" }}>
        <Form.Item
          name="email"
          rules={[
            {
              type: "email",
              message: "Invalid email format",
            },
          ]}
        >
          <Input
            value={email}
            size="large"
            addonBefore={<MailOutlined />}
            placeholder="Email"
            onChange={(e) => {
              onChange({ email: e.target.value });
            }}
          />
        </Form.Item>

        <Form.Item name="website" style={{ width: "100%" }}>
          <Input
            value={website}
            size="large"
            addonBefore="https://"
            onChange={(e) => {
              const value = e?.target?.value?.replace(/\s+/g, ""); // Remove all spaces
              form?.setFieldsValue({ website: value });
              onChange({ website: value });
            }}
          />
        </Form.Item>
      </Form>
    </Row>
  );
};

export default Contact;
